import Vue from 'vue';
import OnlineDialog from '../components/OnlineDialog';
import { Api, Codes } from 'api';
import Login from './login';
export default class {
  constructor(key) {
    this.key = key || 'HSYLC_2021_ONLINE_TIP_READED';
    this.init();
  }
  async init() {
    // if (Login.isLogin()) {
    //   let isNew = false;
    //   Api.get.getStudentSuccessCardStatus().then(res => {
    //     if (res.status === Codes.SUCCESS && res.data && res.data.cards) {
    //       isNew = res.data.cards.is_new;
    //       if (!isNew) {
    //         Api.get.getUserStatus().then(res => {
    //           if (res.status === Codes.SUCCESS && res.data && res.data.is_tuition_paid && !localStorage.getItem(this.key)) {
    //             this.show();
    //           }
    //         });
    //       }
    //     }
    //   });
    // }
  }
  show() {
    const DialogConstructor = Vue.extend(OnlineDialog);
    this.instance = new DialogConstructor();
    this.vm = this.instance.$mount();
    this.$el = this.vm.$el;
    this.dom = this.$el;
    document.body.appendChild(this.$el);
  }
  hide() {
    this.instance.$destroy();
    this.dom.remove();
  }
  setRead() {
    localStorage.setItem(this.key, '1');
  }
}
